import React, { useState, useEffect } from "react";
import { customAlphabet } from "nanoid/non-secure";
import UIActions from "../../actions/UIActions";
import TextInput from "./TextInput";

const DEFAULT_RENDER_LAMBDA_NAME = "test-showitRenderSite";
const DEFAULT_RENDER_VERSION = "$LATEST";
const nanoid = customAlphabet("1234567890abcdef", 5);

const RendererPreview = ({ onHidePanel }) => {
  const [lambdaName, setLambdaName] = useState(DEFAULT_RENDER_LAMBDA_NAME);
  const [lambdaVersion, setLambdaVersion] = useState(DEFAULT_RENDER_VERSION);
  const [previewId, setPreviewId] = useState(nanoid());
  const [error, setError] = useState("");

  const canPreview = () => {
    setError("");
    !lambdaName.trim() && setError("Lambda Name is required");
    !lambdaVersion.trim() && setError("Lambda version is required");
    !previewId.trim() && setError("Preview ID is required");
    !!previewId &&
      previewId.trim().match(/[A-Za-z0-9-._~:/?#\[\]@!$&'()*+,;%=]+/g)?.[0] !== previewId &&
      setError("Preview ID not URL friendly");
    return !error;
  };

  useEffect(() => {
    canPreview();
  }, [lambdaName, lambdaVersion, previewId]);

  const _onPreview = () => {
    if (!error) {
      const config = { lambdaName, lambdaVersion, previewId };
      UIActions.previewOpen(config);
      onHidePanel();
    }
  };

  return (
    <div className={"renderer-preview"}>
      <div className={"renderer-preview-header"}>
        <label style={{ color: "var(--text-base-primary)" }}>Renderer Preview</label>
      </div>
      <div className={"renderer-preview-body"}>
        <div
          className={"renderer-preview-inputs"}
          onKeyUp={(e) => e.key === "Enter" && _onPreview()}
        >
          <TextInput
            label={"Lambda Name"}
            value={lambdaName}
            onChange={setLambdaName}
            placeholder={"Lambda Name"}
          />
          <TextInput
            label={"Lambda Version"}
            value={lambdaVersion}
            onChange={setLambdaVersion}
            placeholder={"Lambda Version"}
          />
          <TextInput
            label={"PreviewID"}
            value={previewId}
            onChange={setPreviewId}
            placeholder={"PreviewID"}
          />
          {error && <div style={{ color: "#991515", textAlign: "center" }}>{error}</div>}
        </div>
        <button
          onClick={_onPreview}
          style={{ marginBottom: "15px" }}
          className="si-c-btn si-c-btn--primary"
        >
          Preview
        </button>
      </div>
    </div>
  );
};

export default RendererPreview;
